import React, { memo, useState } from 'react';
import { Button } from 'react-admin';
import ChangeRateStructureConfirmDialog from './ChangeRateStructureConfirmDialog';

const ChangeRateStructureButton = () => {
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  return (
    <>
      <Button label="Change Rate Structure" onClick={() => setIsConfirmDialogOpen(true)} />
      <ChangeRateStructureConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
      />
    </>
  );
};

export default memo(ChangeRateStructureButton);
